module.exports = __webpack_public_path__ + "media/assets/site_images/partner_logos/plagecor_logo-55cfe94b7e58745b67a9d14efaf8d6d6.png";